import React from 'react';
import { WixPatternsDashboardTestProvider } from './WixPatternsDashboardTestProvider';
import { WixPatternsProviderProps } from './WixPatternsDashboardBaseProvider';
import { WixPatternsDashboardProviderInternal } from './WixPatternsDashboardProviderInternal';

export function WixPatternsProviderInternal(props: WixPatternsProviderProps) {
  if (process.env.NODE_ENV === 'test') {
    return <WixPatternsDashboardTestProvider {...props} />;
  }

  return <WixPatternsDashboardProviderInternal {...props} />;
}
